<div class="modal-header">
    <h4 class="modal-title" paflabel="Dupliquer_un_fournisseur"></h4>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
    </button>
</div>
<div class="modal-body">
    <form name="frmDup" #frmDup="ngForm">
        <div *ngIf="newSupplier.FunctionalId=='siret'">
            <div class="row">
                <div class="col">
                    <label class="control-label" paflabel="Num_Siret"></label>
                    <input name="siret" 
                    noBlankString 
                    onlyNumbers 
                    siretValidator 
                    [supplierId]="supplierSrc?.Id"
                    siretUnique 
                    siretActif 
                    minlength="14" 
                    maxlength="14"
                        class="form-control" type="text" [(ngModel)]="newSupplier.Siret" (blur)="findSiret()"
                        [ngModelOptions]="{updateOn: 'blur'}" required
                        mask="00000000000000">
                </div>
            </div>
            <validation-errors [form]="frmDup" controlName="siret"></validation-errors>
        </div>
        <div *ngIf="newSupplier.FunctionalId=='tvaintra'">
            <div class="row">
                <div class="col">
                    <label class="control-label" paflabel="Num_Intratva"></label>
                    <input name="tvaIntra" class="form-control" type="text" [(ngModel)]="newSupplier.TvaIntra"
                    noBlankString 
                    [intraTvaValidator]="supplierSrc"
                    intraTvaUnique 
                    onBlurValidator 
                    required>
                    <validation-errors [form]="frmDup" controlName="tvaIntra"></validation-errors>
                </div>
            </div>
        </div>
        <div *ngIf="newSupplier.FunctionalId=='duns'">
            <label class="control-label" paflabel="Num_DUNS"></label>
            <input name="duns" class="form-control" type="text" [(ngModel)]="newSupplier.Duns" 
            required 
            noBlankString 
            dunsUnique>
            <validation-errors [form]="frmDup" controlName="duns"></validation-errors>
        </div>
        <div *ngIf="newSupplier.FunctionalId=='rsa'">
            <label class="control-label" paflabel="Num_RSA"></label>
            <input name="rsa" class="form-control" type="text" [(ngModel)]="newSupplier.Rsa" 
            noBlankString
            required 
            maxlength="14"  
            onlyNumbers 
            rsaUnique>
            <validation-errors [form]="frmDup" controlName="rsa"></validation-errors>
        </div>
    </form>
    <!-- Si on trouve un établissement, on l'affiche ici-->
    <div *ngIf="inseeEtablissement">        
        <div class="card-body collapse show" id="votreentreprisecard">
            <div>
                <div class="row">
                    <div class="col-5">
                        <label class="control-label" paflabel="Raison_sociale_du_fournisseur"></label>
                        <input type="text" class="form-control" name="newSupplierName" [(ngModel)]="newSupplier.SupplierName" disabled />
                    </div>
                </div>
                <div *ngIf="address">
                    <div class="row">
                        <div class="col-2">
                            <label class="control-label" paflabel="Num_dans_la_rue"></label>
                            <input type="text" class="form-control" name="AddrNum" [(ngModel)]="address.AddrNum" disabled/>
                        </div>
                        <div class="col-10">
                            <label class="control-label" paflabel="Adresse"></label>
                            <input type="text" class="form-control" name="addr1" [(ngModel)]="address.Addr1" disabled />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <label class="control-label" paflabel="Complement_d_adresse"></label>
                            <input type="text" class="form-control" name="addr2" [(ngModel)]="address.Addr2" disabled />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <label class="control-label" paflabel="Code_postal"></label>
                            <input type="text" class="form-control" name="codepostal" onlyNumbers maxlength="9" [(ngModel)]="address.PostalCod" disabled />
                        </div>
                        <div class="col-9">
                            <label class="control-label" paflabel="Ville"></label>
                            <input type="text" class="form-control" name="city" [(ngModel)]="address.City" disabled />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <form name="frmMotif" #frmMotif="ngForm">
        <div class="row">
                <div class="col">
                    <label class="control-label" paflabel="Motif"></label>
                    <input name="Motif" 
                        noBlankString 
                        required
                        class="form-control" type="text" [(ngModel)]="duplicateParameters.Motif">
                </div>
            </div>
            <validation-errors [form]="frmMotif" controlName="Motif"></validation-errors>
    </form>
</div>
<div class="modal-footer text-center">
    <button type="button" class="btn btn-warning" (click)="cancel()" paflabel="Fermer"></button>
    <button type="button" class="btn btn-info" (click)="checkValidity()"
        *ngIf="!frmDup.valid">Vérifier</button>
    <button type="button" class="btn btn-success" (click)="validate()" paflabel="Dupliquer"
        *ngIf="frmDup.valid" [disabled]="frmMotif.invalid"></button>
</div>